import AbstractComponent from "./abstract-component.js";

class NameInput extends AbstractComponent {
  constructor(index = 0) {
    super(index);
    this._index = index;
  }

  getTemplate() {
    return `<label class="form__label form__label--half">
    <input type="text" name="name-tourist-" id="form-name-tourist-${this._index}" placeholder="Name of tourist"
      class="form__input form__input--tourist-name" pattern="^[a-zA-Z]+$">
  </label>`;
  }
}

export default NameInput;
